<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
                        <div class="row">
                            <div class="col-md-12">
                                <vs-breadcrumb align="left" :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Conducted Training',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                                <div class="heading mt-3">
                                    <h3 class="text-secondary">Conducted Events</h3>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <h6 class="sub-frm-title">
                                Conducted Events Assigned by M & E
                            </h6>
                            <div class="col-sm-12">
                                <!-- new form popup starts -->
                                <b-card>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-stripped">
                                                        <tr>
                                                            <th>Sr#</th>
                                                            <th>Title</th>
                                                            <!--  <th>Code</th> -->
                                                            <th>Created at</th>
                                                            <th class="text-center">Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                        <tr v-for="(item, index) in trainingArr" v-bind:key="item.id">
                                                            <td>{{index+1}}</td>
                                                            <td class="text-capitalize">{{item.title}}</td>
                                                            <!--  <td class="text-uppercase">{{item.training_code}}</td> -->
                                                            <td>
                                                                {{formatDate(item.createdAt)}}
                                                            </td>
                                                            <td v-if="item.status == 'advisorpending'">
                                                                <vs-chip class="mr-1" color="danger">
                                                                    <Strong style="font-size:12px;">Pending</Strong>
                                                                </vs-chip>
                                                            </td>
                                                            <td v-else><code>Not defined yet</code></td>
                                                            <td>
                                                                <b-button pill variant="outline-primary" @click="assignTraining(item.training_code)" size="sm" class="mr-1">Assign
                                                                </b-button>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                                <!-- new form popup ends -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import {
    formatDate
} from "@/utils/DateFormate";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
    data: () => ({
        isSidebar: false,
        trainingArr: [],
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // Set the initial number of items
        this.unassignedTrainings();
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    methods: {
        formatDate,
        // this will route to training wizard
        assignTraining(code) {
            this.$router.push({
                path: '/dashboard/advisor/training-Assignment',
                query: {
                    trainingId: code
                }
            });
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        unassignedTrainings: function unassignedTrainings() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/advisor/get/all/unsigned/to_officer/training/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingArr = response.data;
                });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.title = "";
            this.code = "";
        },

    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.addnew-btn {
    font-size: 12px;
    box-shadow: none;
    border-color: #6c757d;
    background-color: #6c757d;
    float: right;
    margin: 10px 0px;
}

.save-btn {
    box-shadow: none;
    font-size: 12px;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.delete-btn {
    font-size: 12px;
    box-shadow: none;
    /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
    float: right;
    margin: 10px 0px 0px 5px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #ffffff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.display-table li {
    float: left;
    padding: 5px 5px;
}

.display-table li a {
    cursor: inherit;
    font-size: 14px;
    display: block;
    color: #747679;
    text-align: center;
    padding: 5px;
    text-decoration: none;
    background-color: #f1f1f1;
}

.tbl-head th {
    font-weight: 400 !important;
    color: rgba(7, 167, 225, 0.61);
}

.display-table {
    /* margin-bottom: 0px !important; */
    color: #8e8e8e;
}

.display-table th,
.display-table td {
    padding: 5px 10px !important;
    /* border: 1px dotted #07a7e14f; */
}
</style>
